import AddIcon from "@mui/icons-material/Add";
import { Button, type SxProps } from "@mui/material";

import { cmpBaseColors } from "../../../../../../../cmpBaseColors";
import { ThemeModes } from "../../../../../../../muiThemeTypes";

export const ReferencedFieldAddButton = ({
  disabled,
  onClick,
  sx,
}: {
  disabled?: boolean;
  onClick: () => void;
  sx?: SxProps;
}) => (
  <Button
    variant="contained"
    color="inherit"
    disabled={disabled}
    sx={[
      ({ palette }) => ({
        minWidth: "unset",
        width: 40,
        height: 40,
        backgroundColor:
          palette.mode === ThemeModes.LIGHT ? cmpBaseColors.backgroundLight : palette.general.backgroundDark,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        borderStyle: "solid",
        borderWidth: "1px 1px 1px 0",
        borderColor: "general.outlineBorder",
        transitionProperty: "background-color, box-shadow, color",
        "&:hover:not(.Mui-disabled)": {
          backgroundColor: "action.hover",
        },
      }),
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
    disableElevation
    onClick={onClick}
  >
    <AddIcon sx={({ palette }) => ({ fill: palette.action.active })} />
  </Button>
);
